import { render, staticRenderFns } from "./CabeceraModalCrear.vue?vue&type=template&id=62e3cfd2&"
import script from "./CabeceraModalCrear.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalCrear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports